import mock from '../mock'
import jwt from 'jsonwebtoken'
import axios from 'axios'

import { BackendUrl } from '@src/BackendUrl'


//DotEnv Secret Keys
const { REACT_APP_SECRET, REACT_APP_REFRESH_TOKEN_SECRET} = process.env

// ! These two secrets shall be in .env file and not in any other file
const jwtConfig = {
  secret: `${REACT_APP_SECRET}`,
  refreshTokenSecret: `${REACT_APP_REFRESH_TOKEN_SECRET}`,
  expireTime: '5m',
  refreshTokenExpireTime: '5m'
}

//OLD LOGIC BY DEFAULT **-* DISABLED!!! PLEON OI USERS DEN MPAINOUN KARFWTA
const data = {
  users: [
    {
      id: 1,
      fullName: 'Panos Mavroukas',
      username: 'Panos - apo karfwto data sto fakedb/jwt/index.js',
      password: '1',
      avatar: require('@src/assets/images/portrait/small/avatar-s-11.jpg').default,
      email: 'p.mavroukas@dirigo.gr',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 2
      }
    },
    {
      id: 2,
      fullName: 'Jane Doe',
      username: 'janedoe',
      password: 'client',
      avatar: require('@src/assets/images/avatars/1-small.png').default,
      email: 'client@demo.com',
      role: 'client',
      ability: [
        {
          action: 'read',
          subject: 'ACL'
        },
        {
          action: 'read',
          subject: 'Auth'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    }
  ]
}

//**-* Old Login Logic 
mock.onPost('/jwt/login123456').reply(request => {
  const { email, password } = JSON.parse(request.data)

  let error = {
    email: ['Something went wrong']
  }

  const user = data.users.find(u => u.email === email && u.password === password)

  if (user) {
    try {
      const accessToken = jwt.sign({ id: user.id }, jwtConfig.secret, { expiresIn: jwtConfig.expireTime })
      const refreshToken = jwt.sign({ id: user.id }, jwtConfig.refreshTokenSecret, {
        expiresIn: jwtConfig.refreshTokenExpireTime
      })

      const userData = { ...user }

      delete userData.password

      const response = {
        userData,
        accessToken,
        refreshToken
      }

      console.log("Res to check from old logic : ", response)

      return [200, response]
    } catch (e) {
      error = e
    }
  } else {
    error = {
      email: ['Email or Password is Invalid']
    }
  }

  return [400, { error }]
})

//**-* NEW LOGIN LOGIC FROM DATABASE
mock.onPost('/jwt/login')
  .reply(async request => {
  const { email, password } = JSON.parse(request.data)

  // let error = {
  //   email: ['Something went wrong']
  // }
  let error

  const result = await axios.post(`${BackendUrl()}/auth/login`, {email, password})

  const user = result.data?.userData
  const accessToken = result.data?.token

  if (user) {
    try {
      // const accessToken = jwt.sign({ id: user.id }, jwtConfig.secret, { expiresIn: jwtConfig.expireTime })
      // const refreshToken = jwt.sign({ id: user.id }, jwtConfig.refreshTokenSecret, {
      //   expiresIn: jwtConfig.refreshTokenExpireTime
      // })
    
      const userData = { ...user }
    
      delete userData.password
    
      const responseServer = {
        userData,
        accessToken//,
        //refreshToken
      }
    
      return [200, responseServer]
    } catch (e) {
      //console.log("Error at user", e)
      error = e
    }
  } else {
    error = result.data.error
  }
  return [400, { error }]
})

//**-* NEW REGISTER LOGIC FROM DATABASE
mock.onPost('/jwt/register').reply(async request => {
  if (request.data.length > 0) {
    const { email, password, passwordConfirm } = JSON.parse(request.data)

    const checkUser = await axios.post(`${apiUrl}/auth/register/check`, {email, password, passwordConfirm}) 

    const isEmailAlreadyInUse = (checkUser.data.email === email) ? email : false 
    const passwordsMatch = (password === passwordConfirm) ? password : false

    const error = {
      email: isEmailAlreadyInUse ? 'This email is already in use.' : null,
      password: passwordsMatch ? null : 'Passwords dont match.'
    }

    //IF both errors are null then we register the user!
    if (!error.email && !error.password) {

      const userData = await axios.post(`${apiUrl}/auth/register`, {email, password}) 

      const accessToken = jwt.sign({ id: userData.data.id }, jwtConfig.secret, { expiresIn: jwtConfig.expireTime })

      const user = Object.assign({}, userData.data)

      delete user['password']
      delete user['passwordConfirm']
      const response = { user, accessToken }

      return [200, response]
    } else {
      return [200, { error }]
    }
  }
})


mock.onPost('/jwt/refresh-token').reply(async request => {
  const { refreshToken } = JSON.parse(request.data)

  //console.log("Panos Refresh Token with : ", request.data)

  try {
    const { id } = jwt.verify(refreshToken, jwtConfig.refreshTokenSecret)

    //**-* Old Search logic 
    //const userData = { ...data.users.find(user => user.id === id) }
    const userData = await axios.post(`${apiUrl}/auth/refreshtoken`, {id})

    const newAccessToken = jwt.sign({ id: userData.id }, jwtConfig.secret, { expiresIn: jwtConfig.expiresIn })
    const newRefreshToken = jwt.sign({ id: userData.id }, jwtConfig.refreshTokenSecret, {
      expiresIn: jwtConfig.refreshTokenExpireTime
    })

    delete userData.password
    const response = {
      userData,
      accessToken: newAccessToken,
      refreshToken: newRefreshToken
    }

    return [200, response]
  } catch (e) {
    const error = 'Invalid refresh token'
    return [401, { error }]
  }
})
